import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { safelySetInnerHTML } from '@udemy-v2/utils';
import { ShowMore } from '@udemy-v2/react-reveal-components';
import { useI18n } from '@udemy-v2/i18n';
import classNames from 'classnames';
import styles from './instructor-description.module.scss';
export interface InstructorDescriptionProps {
  description: string;
}

/**
 * InstructorDescription component displays a brief description of the instructor.
 *
 * @component
 * @example
 * ```jsx
 * <InstructorDescription description="This is a brief description of the instructor." />
 * ```
 *
 * @param {InstructorDescriptionProps} props - The properties for the component.
 * @param {string} props.description - A brief description of the instructor.
 *
 * @returns {JSX.Element} A React component that renders the instructor's description.
 */
export const InstructorDescription = t0 => {
  const $ = _c(13);
  const {
    description
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("ud-text-sm", styles.description);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== gettext) {
    t2 = gettext("Show less about the instructor");
    $[1] = gettext;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== gettext) {
    t3 = gettext("Show more about the instructor");
    $[3] = gettext;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== description) {
    t4 = safelySetInnerHTML({
      descriptionOfCaller: "instructor-description:description-content",
      html: description,
      dataPurpose: "description-content"
    });
    $[5] = description;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div {...t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <div className={t1}><ShowMore ariaLabelExpanded={t2} ariaLabelCollapsed={t3} collapsedHeight={146} withGradient={true}>{t5}</ShowMore></div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};